__turbopack_context__.v({
  "container": "organization-signup-text-module-scss-module__dcIECG__container",
  "description": "organization-signup-text-module-scss-module__dcIECG__description",
  "panel": "organization-signup-text-module-scss-module__dcIECG__panel",
});
